import React from "react";
import {
  U3140PdfAnnotationEditorDialog,
  type U3140PdfAnnotationEditorDialogProps,
} from "../../../../u3140PdfAnnotations/components/form/U3140PdfAnnotationEditorDialog";
import { U3141ROLES } from "../../../U3141";

export type U3141PdfAnnotationEditorDialogProps = Omit<
  U3140PdfAnnotationEditorDialogProps,
  "documentLogicalUnit" | "presetEditRole"
> &
  Partial<Pick<U3140PdfAnnotationEditorDialogProps, "i18nNamespace">>;

/** Dialogue d’annotations PDF : délègue à U3140 avec le préfixe API enregistre foncier (U3141). */
export const U3141PdfAnnotationEditorDialog: React.FC<U3141PdfAnnotationEditorDialogProps> = ({
  i18nNamespace = "u3140",
  ...rest
}) => (
  <U3140PdfAnnotationEditorDialog
    {...rest}
    i18nNamespace={i18nNamespace}
    documentLogicalUnit="U3141"
    presetEditRole={U3141ROLES.EDITPRESET}
  />
);
